<template>
  <resource-box name="各类农资储备占比">
    <div class="recyLing" slot="content">
      <template v-if="materials.length" >
        <div class="title">
          <div>
            <p class="text">{{ this.result.toFixed(2) || 0 }}</p>
            <p class="subtext">总数</p>
          </div>
        </div>
        <div class="echarts" id="mains"></div>
      </template>
      <el-empty
        :image="require('@/assets/recycling/index/empty.svg')"
        description="暂无数据"
        style="height: inherit"
        v-else
      />
    </div>
  </resource-box>
</template>

<script>
import * as echarts from 'echarts';
import ResourceBox from '@/views/ChinaMapData/components/common/resourceBox.vue';
import { autoToolTip } from '@/util/echarts_auto_tooltip';
import { getAreaStoreCount } from '@/API/chinaMapApi/chinaMapApi';
export default {
  name: 'PieChart',
  components: {
    ResourceBox,
  },
  watch: {
    '$store.state.chinaMap.dataType': {
      handler: function () {
        this.getAreaStoreAmount();
      },
    },
    '$store.state.chinaMap.timeId': {
      handler: function () {
        this.getAreaStoreAmount();
      },
    },
    '$store.state.chinaMap.currentlyMapAdcode': {
      handler: function () {
        this.getAreaStoreAmount();
      },
    },
    '$store.state.chinaMap.companyId': {
      handler: function () {
        this.getAreaStoreAmount();
      },
    },
  },
  data() {
    return {
      materials: [],
      AmountOfRecycling: 0,
      Data: [],
      result: 0,
      myChart: '',
      oldWidth: null,
      oldHeight: null,
      Resize: null,
      color: [
        '#00EAFF',
        '#549BFF',
        '#B1FCEA',
        '#6DE36F',
        '#FAD550',
        '#00BAAD',
        '#775DF7',
        '#4D87FD',
        '#48BFFB',
      ],
      tooltipAutoPlay: null, // 存储 autoToolTip 返回的对象，用于清理
    };
  },
  created() {},
  mounted() {
    this.getAreaStoreAmount();
    // 存储初始容器的宽高
    setTimeout(() => {
      const oldContainer = document.getElementById('mains'); // 替换为你的容器 ID
      const { width, height } = oldContainer.getBoundingClientRect();
      this.oldWidth = width;
      this.oldHeight = height;
    }, 500);
    // 2. 强制更新 ECharts 内部容器和 canvas 的宽高
    const that = this;
    // 处理尺寸变化的核心函数
    const handleResize = () => {
      if (!that.myChart) return;

      // 1. 获取绑定的 DOM 容器最新尺寸（已自适应全屏的容器）
      const container = document.getElementById('mains'); // 替换为你的容器 ID
      if (!container) return;

      // 2. 强制更新 ECharts 内部容器和 canvas 的宽高
      const { width, height } = container.getBoundingClientRect();

      // 3. 获取 ECharts 内部容器（通常是第一个子元素）并设置尺寸
      const echartsInnerContainer = container.firstChild;
      if (echartsInnerContainer) {
        echartsInnerContainer.style.width = `${width}px`;
        echartsInnerContainer.style.height = `${height}px`;
      }

      // 4. 获取 canvas 元素并强制设置尺寸（解决 canvas 绘制尺寸不更新问题）
      const canvas = container.querySelector('canvas');
      if (canvas) {
        // 注意：canvas 的 width/height属性（绘制尺寸）和style.width/style.height（显示尺寸）需同步
        canvas.width = width;
        canvas.height = height;
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;
      }
      // 5. 触发 ECharts 重绘（确保所有组件重新布局）
      setTimeout(() => {
        that.myChart.resize({
          width: width, // 显式指定新宽度
          height: height, // 显式指定新高度
        });
      }, 200); // 微延迟确保 DOM 更新后执行
    };

    // 绑定事件监听（覆盖所有可能的尺寸变化场景）
    window.addEventListener('resize', handleResize);
    document.addEventListener('fullscreenchange', handleResize);
    document.addEventListener('webkitfullscreenchange', handleResize);
    document.addEventListener('mozfullscreenchange', handleResize);
    document.addEventListener('msfullscreenchange', handleResize);

    // 组件销毁时清理
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('fullscreenchange', handleResize);
      document.removeEventListener('webkitfullscreenchange', handleResize);
      document.removeEventListener('mozfullscreenchange', handleResize);
      document.removeEventListener('msfullscreenchange', handleResize);
      that.disposeChart(); // 清理图表实例和轮播
    });
    this.Resize = handleResize;
  },
  methods: {
    // 清理图表实例和轮播
    disposeChart() {
      // 1. 清理自动轮播
      if (this.tooltipAutoPlay && typeof this.tooltipAutoPlay.clearLoop === 'function') {
        this.tooltipAutoPlay.clearLoop();
        this.tooltipAutoPlay = null;
      }

      // 2. 销毁 ECharts 实例
      if (this.myChart) {
        this.myChart.dispose();
        this.myChart = null;
      }
    },

    // 新增数据处理方法
    processMaterials(materials, result) {
      let dataArray = [];
      materials.forEach((item) => {
        dataArray.push({
          value: Number(item.amount),
          name: item.name,
          percentage: `${((Number(item.amount) / result) * 100).toFixed(2)}%`,
        });
      });
      this.Data = [...dataArray];
      console.log(this.Data, materials, 'Data');

      // 先清理旧图表，再初始化新图表
      this.disposeChart();

      setTimeout(() => {
        this.initEcharts();
      }, 350);
    },
    initEcharts() {
      // 1. 获取绑定的 DOM 容器最新尺寸（已自适应全屏的容器）
      const container = document.getElementById('mains'); // 替换为你的容器 ID
      if (!container) return;
      // 2. 强制更新 ECharts 内部容器和 canvas 的宽高
      let chartDom = document.getElementById('mains');
      if (!chartDom) return;

      // 如果已有实例，先销毁（双重保险）
      if (this.myChart) {
        this.myChart.dispose();
      }

      this.myChart = echarts.init(chartDom);
      let option = {
        color: [
          '#00EAFF',
          '#549BFF',
          '#B1FCEA',
          '#6DE36F',
          '#FAD550',
          '#00BAAD',
          '#775DF7',
          '#4D87FD',
          '#48BFFB',
        ],
        tooltip: {
          trigger: 'item',
          padding: 0,
          formatter: function (parmars) {
            let DOM1 = `<div style="width: auto;line-height: 25px;color: black;font-weight:500;padding: 10px;background: ${parmars.color}">
                        <span style="font-weight: 400">${parmars.name}：</span><span>${parmars.value}</span> / <span>${parmars.percent}%</span>
                        </div>`;
            return DOM1;
          },
          position: function (pos, params, dom, rect, size) {
            // 计算四个可能的位置
            const positions = {
              top: [
                pos[0] - size.contentSize[0] / 2,
                pos[1] - size.contentSize[1] - 10,
              ],
              bottom: [pos[0] - size.contentSize[0] / 2, pos[1] + 20],
              left: [
                pos[0] - size.contentSize[0] - 15,
                pos[1] - size.contentSize[1] / 2,
              ],
              right: [pos[0] + 15, pos[1] - size.contentSize[1] / 2],
            };

            // 找出完全在可视区域内的位置
            for (const [key, [x, y]] of Object.entries(positions)) {
              if (
                  x >= 10 &&
                  x + size.contentSize[0] <= rect.width - 10 &&
                  y >= 10 &&
                  y + size.contentSize[1] <= rect.height - 10
              ) {
                return [x, y];
              }
            }

            // 默认返回顶部位置（即使部分超出）
            return positions.top;
          },
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['65%', '85%'],
            center: ['50%', '50%'],
            label: {
              show: true,
              color: '#fff',
              fontSize: 16,
            },
            labelLine: {
              show: true,
              length: 15, // 第一段线长度
              length2: 20, // 第二段线长度
              lineStyle: {
                width: 2, // 连接线粗细（核心配置，默认 1，可改 3/4 等）
              },
            },
            data: this.Data,
          },
        ],
      };
      this.myChart.setOption(option);

      // 清理旧的轮播后再启动新的轮播
      if (this.tooltipAutoPlay && typeof this.tooltipAutoPlay.clearLoop === 'function') {
        this.tooltipAutoPlay.clearLoop();
      }

      this.tooltipAutoPlay = autoToolTip(this.myChart, option, {
        // 轮播间隔时间 默认 2s
        interval: 2000,
        // 是否循环轮播所有序列
        loopSeries: false,
        // 第 1 个被轮播的序列下标
        seriesIndex: 0,
      });
    },
    getAreaStoreAmount() {
      let params = {
        types: this.$store.state.chinaMap.dataType == 1 ? '1,3' : '2,3',
        subId: this.$store.state.chinaMap.timeId || '',
        region: this.$store.state.chinaMap.currentlyMapAdcode || '',
        dataType: this.$store.state.chinaMap.currentlyMapAdcode
            ? this.$store.state.chinaMap.dataType
            : '',
        companyId: this.$store.state.chinaMap.companyId || ''
      };
      getAreaStoreCount(params).then((res) => {
        this.result = 0;
        if (res.code == 200) {
          this.materials = res.data;
          this.materials.forEach((item) => {
            this.result += item.amount;
          });
          this.processMaterials(this.materials, this.result.toFixed(2));
        } else {
          // 接口失败时也清理图表
          this.disposeChart();
          this.materials = [];
          this.Data = [];
        }
      });
    },
  },
};
</script>


<style lang="less" scoped>
.recyLing {
  width: 100%;
  height: 100%;
  position: relative;
  .echarts {
    width: 100%;
    height: 100%;
  }
}
.title {
  border: 5px solid #033045;
  width: 190px;
  height: 190px;
  border-radius: 50%;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  .text {
    width: inherit;
    font-size: 26px;
    color: #ffffff;
    text-align: center;
  }
  .subtext {
    width: inherit;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
  }
}
</style>
